import { APP_PERMISSIONS } from '@exam-center/permission';
import { AddIcon, Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { AddExamCenterMemberModal } from '../add-exam-center-member-modal';

type AddExamCenterMemberButtonProps = Pick<ButtonProps, 'variant' | 'size'>;

export default function AddExamCenterMemberButton(props: Readonly<AddExamCenterMemberButtonProps>) {
  const { variant = 'contained', size = 'medium' } = props;

  const [isOpen, addExamCenterMemberModalHandlers] = useDisclosure();
  const { open: openAddExamCenterMemberModal, close: closeAddExamCenterMemberModal } =
    addExamCenterMemberModalHandlers;

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.CREATE}>
      <Button
        size={size}
        variant={variant}
        startIcon={<AddIcon />}
        onClick={openAddExamCenterMemberModal}
      >
        เพิ่มสมาชิก
      </Button>
      <AddExamCenterMemberModal open={isOpen} onClose={closeAddExamCenterMemberModal} />
    </WithPermission>
  );
}
